import React from "react";
import { ExportButton } from "components/buttons";
import { EmissionsAllocationExportRequestBody, exportEmissionsAllocationSummary } from "api";
import { validateExportParams } from "utils";

export const ExportCSVButton = ({ query }: { query: EmissionsAllocationExportRequestBody }) => (
    <ExportButton
        exportFunction={exportEmissionsAllocationSummary}
        exportParams={query}
        exportText="Export CSV"
        exportingText="Exporting CSV..."
        successMessage="CSV exported successfully."
        isZipFile={false}
        exportTitle="emissions-allocation-summary"
        onBeforeExport={validateExportParams}
        sx={{
            borderRadius: "8px",
            width: '204px',
            height: '36px',
            fontWeight: 500
        }}
    />
);